import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";


function Category() {
    const [category, setCategory] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate(); // ✅ use navigate instead of window.location
    const token = localStorage.getItem("token");
    

    const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this category?")) return;

  try {
    const { data } = await apiClient.delete(ADMIN.DELETE_CATEGORY(id));
    if (!data.success) throw new Error(data.message || "Delete failed");

    toast.success("Category deleted successfully");
    setCategory(category.filter((c) => c._id !== id));
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Failed to delete category");
  }
};

const handleEdit = (categoryData) => {
    // Option 1: Navigate with query param
    navigate(`/addcategory?id=${categoryData._id}`);

    // Option 2: open a modal pre-filled with paymentData
  };

    useEffect(() => {
      const fetchcategory = async () => {
        try {
          const { data } = await apiClient.get(ADMIN.GET_CATEGORY);
          if (data.success) {
            setCategory(data.items);
          }
        } catch (err) {
          console.error("Error fetching category:", err);
          toast.error(err.response?.data?.message || err.message || "Failed to fetch categories");
        } finally {
          setLoading(false);
        }
      };
  
      fetchcategory();
    }, []);
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title"> Cataegory Table </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="">Dashboard</a></li>
              <li className="breadcrumb-item active" aria-current="page">Category Table</li>
            </ol>
            <div>
          </div>
          </nav>
        </div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-10">
                    <h4 className="card-title">Category Data</h4>
                    <p className="card-description"></p>
                  </div>
                  <div className="col-2">
                    <a href="./addcategory">
                      <button className="btn-primary">Add Item</button>
                    </a>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th> Sr.No </th>
                        <th> Name </th>
                        <th> Description </th>
                        <th> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">Loading...</td>
                        </tr>
                      ) : category.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">No tables found</td>
                        </tr>
                      ) : (
                        category.map((t, index) => (
                          <tr key={t._id}>
                            <td>{index + 1}</td>
                            <td>{t.name}</td>
                            <td>{t.description}</td>
                            <td>
                              
                              <button
                                className="btn btn-primary me-2"
                                onClick={() => handleEdit(t)}
                              >
                                Edit
                              </button>
                                <button
                                className="btn btn-danger"
                                onClick={() => handleDelete(t._id)}
                              >Delete</button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Category
